/// <amd-module name="TFS/Token/PatTokenPage/Components/Panels/Panel.Success" />
import { basePanelProps } from 'Components/Panels/Panel.Base';
import { Button, IButtonProps } from "VSSUI/Button";
import { Label } from "OfficeFabric/Label";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { IPanelProps, Panel } from "VSSUI/Panel";
import { mergeStyleSets, FontSizes } from "OfficeFabric/Styling";
import { TextField } from "VSSUI/TextField";
import { getId } from "VSS/Core/Util/Object";
import { memoize } from "VSS/Core/Util/Memoize";
import * as React from 'react';
import * as Resources from "TFS/Token/PatTokenPage/Resources";
import { Token } from 'Models/Token';
import { Location } from 'VSSUI/Utilities/Position';
import { copyToClipboard } from "VSSUI/Clipboard";

export interface ISuccessDialogProps extends IPanelProps {
    token: Token,
}

export interface ISuccessDialogState {
    copiedToken?: boolean;
}

export default class SuccessDialog extends React.Component<ISuccessDialogProps, ISuccessDialogState> {
    private readonly textFiledId = getId("textfield");

    constructor(props: ISuccessDialogProps) {
        super(props);
        this.state = {};
    }

    @memoize
    private static getStyles() {
        return mergeStyleSets({
            footerButtons: {
                marginRight: "16px",
                selectors: {
                    " > * + *": {
                        paddingLeft: "4px",
                    },
                },
            },
            successMessage: {
                fontSize: FontSizes.small,
            },
            tokenTitle: {
                fontSize: FontSizes.medium,
            },
            errorMessage: {
                marginTop: "20px"
            },
            copyTokenContainer: {
                display: "flex",
                flexDirection: "row",
                margin: "12px 0px 12px 0px"
            },
            copyTokenTextArea: {
                flexGrow: 1,
            },
            copyTokenWarningMessage: {
                marginTop: "28px"
            }
        })
    }

    public render() {
        const { token } = this.props;
        const styles = SuccessDialog.getStyles();
        const footerButtons: IButtonProps[] = [{
            onClick: this.props.onDismiss,
            primary: true,
            text: Resources.Close
        }];

        return (
            <Panel
                {...basePanelProps}
                {...this.props}
                titleProps={{ text: Resources.SuccessWithExclamationPoint }}
                footerButtonProps={footerButtons}
            >
                <div>
                    <div className={styles.successMessage}>{Resources.PatTokenAddSuccessDescription}</div>
                    <Label htmlFor={this.textFiledId} className={styles.tokenTitle}>{token.displayName + " " + Resources.Token}</Label>
                    <div className={styles.copyTokenContainer}>
                        {/* Token */}
                        <TextField
                            key={this.textFiledId}
                            className={styles.copyTokenTextArea}
                            value={token.token}
                            readOnly={true}
                            ariaLabel={Resources.Token}
                        />
                        {/* Copy Button */}
                        <Button
                            subtle={true}
                            ariaLabel={Resources.CopyToClipboard}
                            iconProps={{ iconName: 'Copy' }}
                            onClick={this.copyToken}
                            tooltipProps={
                                {
                                    anchorOffset: { horizontal: 0, vertical: 0 },
                                    anchorOrigin: { horizontal: Location.center, vertical: Location.start },
                                    text: this.state.copiedToken ? Resources.Copied : Resources.CopyToClipboard,
                                    tooltipOrigin: { horizontal: Location.center, vertical: Location.end }
                                }
                            }
                        />
                    </div>
                    {/* Warning Message */}
                    <MessageBar
                        className={styles.copyTokenWarningMessage}
                        severity={MessageBarSeverity.Warning}
                    >
                        {Resources.PatTokenAddWarning}
                    </MessageBar>
                </div>
            </Panel>
        )
    }

    private copyToken = (): void => {
        const { token } = this.props;

        copyToClipboard(token.token);

        this.setState({
            copiedToken: true,
        });
    }
}
